import { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOMeta from '@/components/feature/SEOMeta';
import { sportCategories, articles } from '@/mocks/sports';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = sportCategories.find((c) => c.slug === slug) || sportCategories[0];
  const [activeCategory, setActiveCategory] = useState(currentCategory.slug);

  const filteredArticles = articles.filter((a) => a.category === activeCategory);
  const displayCategory = sportCategories.find((c) => c.slug === activeCategory) || currentCategory;

  const categorySchema = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${displayCategory.name} - bb体育`,
    description: displayCategory.description,
    url: `https://www.bbty.com/category/${activeCategory}`,
    isPartOf: {
      '@type': 'WebSite',
      name: 'bb体育',
      url: 'https://www.bbty.com',
    },
  };

  return (
    <>
      <ScrollToTop />
      <SEOMeta
        title={`${displayCategory.name} - bb体育 | ${displayCategory.name}赛事资讯 实时比分`}
        description={displayCategory.description}
        keywords={`bb体育,${displayCategory.name},${displayCategory.name}赛事,${displayCategory.name}直播,${displayCategory.name}比分`}
        canonicalPath={`/category/${activeCategory}`}
        schema={categorySchema}
      />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-100 border-b border-background-200">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: displayCategory.name },
              ]}
            />
            <div className="w-full px-4 md:px-6 pb-8">
              <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
                {displayCategory.name}
              </h1>
              <p className="mt-2 text-sm text-foreground-500">{displayCategory.description}</p>
            </div>
          </div>
        </div>

        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-2 py-4 overflow-x-auto flex-wrap">
              {sportCategories.map((cat) => (
                <button
                  key={cat.slug}
                  onClick={() => {
                    setActiveCategory(cat.slug);
                    window.history.replaceState(null, '', `/category/${cat.slug}`);
                  }}
                  className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                </button>
              ))}
            </div>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-8 md:py-12">
          <div className="max-w-7xl mx-auto">
            {filteredArticles.length > 0 ? (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
                {filteredArticles.map((article) => (
                  <Link
                    key={article.id}
                    to={`/article/${article.slug}`}
                    className="group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-200 transition-all cursor-pointer"
                  >
                    <div className="relative h-48 overflow-hidden bg-background-200">
                      <div className="absolute inset-0 flex items-center justify-center">
                        <i className={`${displayCategory.icon} text-5xl text-foreground-300`}></i>
                      </div>
                    </div>
                    <div className="p-4">
                      <h3 className="text-base font-heading font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors">
                        {article.title}
                      </h3>
                      <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">
                        {article.summary}
                      </p>
                      <div className="flex items-center justify-between mt-3 pt-3 border-t border-background-200">
                        <div className="flex items-center gap-3 text-xs text-foreground-400">
                          <span>{article.author}</span>
                          <span>{article.publishDate}</span>
                        </div>
                        <div className="flex items-center gap-1 text-xs text-foreground-400">
                          <i className="ri-eye-line"></i>
                          <span>{article.views.toLocaleString()}</span>
                        </div>
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-full bg-background-100">
                  <i className={`${displayCategory.icon} text-3xl text-foreground-400`}></i>
                </div>
                <p className="mt-4 text-foreground-500">暂无相关文章</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}